"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FixedMenuLayout = require("../../layouts/FixedMenuLayout");

var _FixedMenuLayout2 = _interopRequireDefault(_FixedMenuLayout);

var _Map = require("../../components/Map/Map");

var _Map2 = _interopRequireDefault(_Map);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _PanelButtonsVisualizations = require("../../components/PanelButtonsVisualizations/PanelButtonsVisualizations");

var _PanelButtonsVisualizations2 = _interopRequireDefault(_PanelButtonsVisualizations);

var _PanelSocialButtons = require("../../components/PanelSocialButtons/PanelSocialButtons");

var _PanelSocialButtons2 = _interopRequireDefault(_PanelSocialButtons);

var _LogoICGC = require("../../components/LogoICGC/LogoICGC");

var _LogoICGC2 = _interopRequireDefault(_LogoICGC);

var _PanelLegendVisualizations = require("../../components/PanelLegendVisualizations/PanelLegendVisualizations");

var _PanelLegendVisualizations2 = _interopRequireDefault(_PanelLegendVisualizations);

var _PanelGetFeatureInfo = require("../../components/PanelGetFeatureInfo/PanelGetFeatureInfo");

var _PanelGetFeatureInfo2 = _interopRequireDefault(_PanelGetFeatureInfo);

var _PanelFilterButtons = require("../../components/PanelFilterButtons/PanelFilterButtons");

var _PanelFilterButtons2 = _interopRequireDefault(_PanelFilterButtons);

var _PanelCercadorMap = require("../../components/PanelCercadorMap/PanelCercadorMap");

var _PanelCercadorMap2 = _interopRequireDefault(_PanelCercadorMap);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

var _Visor = require("./Visor.css");

var _Visor2 = _interopRequireDefault(_Visor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      

/* import PanelPropertiesInfoSelector from "../../components/PanelPropertiesInfoSelector/PanelPropertiesInfoSelector"; */


var Visor = function (_React$Component) {
  _inherits(Visor, _React$Component);

  function Visor(props) {
    _classCallCheck(this, Visor);

    var _this = _possibleConstructorReturn(this, (Visor.__proto__ || Object.getPrototypeOf(Visor)).call(this, props));

    _this.handleWindowSizeChange = function () {
      _this.setState({ width: window.innerWidth });
    };

    var cachedObject = localStorage.getItem(CONSTANTS.JSON_CONFIG_FILE);

    _this.dataJsonConfig = CONSTANTS.jsonConfig;
    _this.state = {
      loading: true,
      showPanelGetFeatureInfo: false,
      currentFeature: {},
      stationsFonts: [],
      showJsonConfigError: false,
      cacheGeoJSON: false,
      currentVis: 0,
      width: window.innerWidth,
      jsonConfig: cachedObject ? _extends({}, JSON.parse(cachedObject)) : CONSTANTS.defaultJsonConfig
    };
    window.addEventListener("resize", _this.handleWindowSizeChange);
    return _this;
  }

  _createClass(Visor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      //console.info("Ha muntat");

      var id = this.getCurrentVisorId();

      _share2.default.loadJsonConfig(CONSTANTS.URL_GET_GEOJSON, id).then(function (data) {
        if (data.ok && data.ok === false) {
          _this2.setState({ loading: false, showJsonConfigError: true });
        } else {
          _this2.dataJsonConfig = data;
          _this2.dataJsonConfig.vieweroptions.isEditor = true;

          //console.info(this.dataJsonConfig.vieweroptions.style.url);

          if (_this2.dataJsonConfig.vieweroptions.style && _this2.dataJsonConfig.vieweroptions.style.url) {
            var url = _this2.dataJsonConfig.vieweroptions.style.url;

            _this2.dataJsonConfig.vieweroptions.style.url = url.replace("https://geostarters.github.io/tv3-styles/styles/", "https://tilemaps.icgc.cat/tileserver/styles/tv3-styles/styles/");
          }
          //console.info(this.dataJsonConfig.vieweroptions.style.url);

          if (_this2.dataJsonConfig.timerange.dynamic || _this2.dataJsonConfig.timerange.tipus === CONSTANTS.LATEST) {
            var _dinamicCheck = _share2.default.checkDinamicTimeRange(_this2.dataJsonConfig.timerange);
            _this2.dataJsonConfig.timerange.timemin = _dinamicCheck.timemin;
            _this2.dataJsonConfig.timerange.timemax = _dinamicCheck.timemax;
            _this2.checkUpdateGeoJSON(_this2.dataJsonConfig).then(function (data) {
              if (data && data.msg === "renew") {
                _this2.setState({ loading: true, cacheGeoJSON: false });
                _this2.checkUpdateGeoJSON(_this2.dataJsonConfig).then(function (data2) {
                  _this2.setState({ loading: false, cacheGeoJSON: true });
                }).catch(function (error) {
                  return console.log(error);
                });
              } else {
                _this2.setState({ loading: false, cacheGeoJSON: true });
              }
            }).catch(function (error) {
              return console.log(error);
            });
          } else {
            //console.info("visor no dinamic");

            _this2.setState({ loading: false, cacheGeoJSON: true });
          }

          var index = _this2.dataJsonConfig.vieweroptions.thematicoptions.findIndex(function (element) {
            return element.isVisible;
          });
          _this2.setState({
            currentVis: index,
            stationsFonts: _this2.dataJsonConfig.vieweroptions.infowindow.viewfiltersources
          });
        }
      }, function (err) {
        console.log(err);
        _this2.setState({ loading: false, showJsonConfigError: true });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowSizeChange);
    }
  }, {
    key: "checkUpdateGeoJSON",
    value: function checkUpdateGeoJSON(configJSON) {
      return new Promise(function (resolve, reject) {
        _request2.default.post(CONSTANTS.URL_VISOR_GEOJSON, configJSON).then(function (data) {
          resolve(data);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: "getCurrentVisorId",
    value: function getCurrentVisorId() {
      if (this.props.match.params.id !== "last") {
        return this.props.match.params.id;
      } else {
        return "600b9b33-3656-4d32-9b64-a6716573c1d6";
      }
    }
  }, {
    key: "getFeatureInfo",
    value: function getFeatureInfo(feature) {
      this.setState({ currentFeature: feature });
      this.setState({ showGetFeatureInfo: true });
    }
  }, {
    key: "updateInfowindowPropsAndUpdateMap",
    value: function updateInfowindowPropsAndUpdateMap(item, val) {
      var newInfowindow = _extends({}, this.dataJsonConfig.vieweroptions.infowindow, _defineProperty({}, item, val));

      this.dataJsonConfig.vieweroptions.infowindow = newInfowindow;
      //this.updateViewerOptions("infowindow", newInfowindow);
      //console.info("arribo");
      this.map.refreshMap();
    }
  }, {
    key: "visualitzacioVisibleChanged",
    value: function visualitzacioVisibleChanged(newIndex) {
      if (this.map) {
        var newThematicOptions = [].concat(_toConsumableArray(this.dataJsonConfig.vieweroptions.thematicoptions));

        newThematicOptions[this.state.currentVis].isVisible = false;
        newThematicOptions[newIndex].isVisible = true;

        this.map.updateLayersVisibilityOfVisualitzacio(newThematicOptions[this.state.currentVis], false, this.state.currentVis);
        this.map.updateLayersVisibilityOfVisualitzacio(newThematicOptions[newIndex], true, newIndex);

        this.setState({ currentVis: newIndex, showGetFeatureInfo: false });
      }
    }
  }, {
    key: "updateTimerange",
    value: function updateTimerange(item, value) {
      this.dataJsonConfig.timerange[item] = value;
    }
  }, {
    key: "zoomToMap",
    value: function zoomToMap(value) {
      var pr = value.split(",");
      this.map.map.fitBounds([[parseFloat(pr[0]), parseFloat(pr[1])], [parseFloat(pr[2]), parseFloat(pr[3])]]);
    }
  }, {
    key: "renderPanelGetFeatureInfo",
    value: function renderPanelGetFeatureInfo() {
      var _this3 = this;

      if (this.state.currentFeature.properties && this.state.showGetFeatureInfo) {
        return _react2.default.createElement(_PanelGetFeatureInfo2.default, {
          modeEdicio: false,
          viewTitleBar: this.dataJsonConfig.vieweroptions.infowindow.viewtitlebar,
          selectedfields: this.dataJsonConfig.selectedfields,
          calcdatafields: this.dataJsonConfig.calcdatafields,
          calcdatafieldsCalculs: this.dataJsonConfig.calcdatafieldsCalculs,
          calcdatafieldsOptions: this.dataJsonConfig.calcdatafieldsOptions,
          selectedfieldsLabels: this.dataJsonConfig.selectedfieldsLabels,
          data: this.dataJsonConfig.data,
          colorPanell: this.dataJsonConfig.vieweroptions.infowindow.colorPanell,
          colorPanellText: this.dataJsonConfig.vieweroptions.infowindow.colorPanellText,
          featureInfo: this.state.currentFeature,
          thematics: this.dataJsonConfig.vieweroptions.thematicoptions,
          timerange: this.dataJsonConfig.timerange,
          showGetFeatureInfo: function showGetFeatureInfo() {
            return _this3.setState({ showGetFeatureInfo: false });
          }
        });
      }
    }
  }, {
    key: "renderPanelLegendVisualization",
    value: function renderPanelLegendVisualization() {
      if (this.dataJsonConfig.vieweroptions.infowindow.viewlegend) {
        return _react2.default.createElement(_PanelLegendVisualizations2.default, {
          width: this.state.width,
          layoutOptions: this.dataJsonConfig.vieweroptions.layoutoptions,
          thematicoptions: this.dataJsonConfig.vieweroptions.thematicoptions
        });
      }
    }
  }, {
    key: "renderPanelsButtonsVisualizations",
    value: function renderPanelsButtonsVisualizations() {
      var _this4 = this;

      if (this.dataJsonConfig.vieweroptions.layoutoptions.opvisual !== CONSTANTS.DEFAULT_OPVISUAL) {
        return _react2.default.createElement(_PanelButtonsVisualizations2.default, {
          width: this.state.width,
          layoutoptions: this.dataJsonConfig.vieweroptions.layoutoptions,
          thematicoptions: this.dataJsonConfig.vieweroptions.thematicoptions,
          visualitzacioVisibleChanged: function visualitzacioVisibleChanged(index) {
            return _this4.visualitzacioVisibleChanged(index);
          },
          isEditor: false,
          currentVis: this.state.currentVis
        });
      }
    }
  }, {
    key: "renderSocialButtonsVisualizations",
    value: function renderSocialButtonsVisualizations() {
      /* const { dataJsonConfig } = this.state; */

      if (this.dataJsonConfig.vieweroptions.layoutoptions.twitter || this.dataJsonConfig.vieweroptions.layoutoptions.facebook) {
        return _react2.default.createElement(_PanelSocialButtons2.default, {
          layoutoptions: this.dataJsonConfig.vieweroptions.layoutoptions,
          thematicoptions: this.dataJsonConfig.vieweroptions.thematicoptions,
          isEditor: false
        });
      }
    }
  }, {
    key: "renderFilterButtonsVisualizations",
    value: function renderFilterButtonsVisualizations() {
      if (this.dataJsonConfig.vieweroptions.infowindow.viewfilter) {
        return _react2.default.createElement(_PanelFilterButtons2.default, {
          infowindow: this.dataJsonConfig.vieweroptions.infowindow,
          thematicoptions: this.dataJsonConfig.vieweroptions.thematicoptions,
          stationsFonts: this.dataJsonConfig.selectedorganizations,
          updateInfowindowPropsAndUpdateMap: this.updateInfowindowPropsAndUpdateMap.bind(this),
          isEditor: false
        });
      }
    }
  }, {
    key: "renderCercadorButtonsVisualizations",
    value: function renderCercadorButtonsVisualizations() {
      //console.info("porp",this.props.dataJsonConfig);
      if (this.dataJsonConfig.vieweroptions.infowindow.viewcercador) {
        return _react2.default.createElement(_PanelCercadorMap2.default, {
          infowindow: this.dataJsonConfig.vieweroptions.infowindow,
          zoomToMap: this.zoomToMap.bind(this),
          isEditor: true
        });
      }
    }
  }, {
    key: "renderPanelLogo",
    value: function renderPanelLogo() {
      if (this.state.width <= 600) {
        return _react2.default.createElement(_LogoICGC2.default, { addText: "ICGC" });
      }

      return _react2.default.createElement(_LogoICGC2.default, null);

      //return (<div></div>);
    }
  }, {
    key: "renderMap",
    value: function renderMap() {
      var _this5 = this;

      if (this.state.cacheGeoJSON) {
        return _react2.default.createElement(
          "div",
          { id: "map" },
          this.renderPanelsButtonsVisualizations(),
          this.renderSocialButtonsVisualizations(),
          this.renderPanelLegendVisualization(),
          this.renderFilterButtonsVisualizations(),
          this.renderCercadorButtonsVisualizations(),
          this.renderPanelGetFeatureInfo(),
          this.renderPanelLogo(),
          _react2.default.createElement(_Map2.default, {
            ref: function ref(instance) {
              return _this5.map = instance;
            },
            vieweroptions: this.dataJsonConfig.vieweroptions,
            datafields: this.dataJsonConfig.selectedfields,
            calcdatafields: this.dataJsonConfig.calcdatafields,
            calcdatafieldsCalculs: this.dataJsonConfig.calcdatafieldsCalculs,
            calcdatafieldsOptions: this.dataJsonConfig.calcdatafieldsOptions,
            panelindex: this.dataJsonConfig.activeIndex,
            getFeatureInfo: this.getFeatureInfo.bind(this),
            updateLayerStyle: function updateLayerStyle() {
              return console.log("updateLayerStyle VISOR");
            },
            getTimeStamps: function getTimeStamps(timestamps) {
              return _this5.updateTimerange("timestamps", timestamps);
            },
            getTimeStampsCalcValue: function getTimeStampsCalcValue(timestampscalcvalue) {
              return console.log("timestampscalcvalue");
            },
            timerange: this.dataJsonConfig.timerange,
            manageGeojsonError: function manageGeojsonError() {
              return console.log("manageGeojsonError VISOR");
            },
            manageGeojsonData: function manageGeojsonData() {
              return console.log("manageGeojsonData VISOR");
            }
          })
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      var organization = this.dataJsonConfig && this.dataJsonConfig.organization ? this.dataJsonConfig.organization : "tv3";

      if (this.state.loading) {
        return _react2.default.createElement(
          "div",
          { className: _Visor2.default.containerMap },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { active: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { size: "massive" },
              "Carregant visor..."
            )
          )
        );
      } else if (this.state.showJsonConfigError) {
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_FixedMenuLayout2.default, { organization: organization, title: "Visor", isVisor: true }),
          _react2.default.createElement(
            "div",
            { className: _Visor2.default.containerError },
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              { className: _Visor2.default.myMessageError, active: true },
              _react2.default.createElement(
                _semanticUiReact.Message,
                { compact: true, negative: true, icon: true },
                _react2.default.createElement(_semanticUiReact.Icon, { name: "circle notched", loading: true }),
                _react2.default.createElement(
                  _semanticUiReact.Message.Content,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Message.Header,
                    null,
                    "ERROR"
                  ),
                  "Problema carregant el VISOR"
                )
              )
            )
          )
        );
      }

      return _react2.default.createElement(
        "div",
        null,
        this.dataJsonConfig.vieweroptions.infowindow.viewtitlebar && _react2.default.createElement(_FixedMenuLayout2.default, {
          organization: organization,
          title: this.dataJsonConfig.vieweroptions.layoutoptions.title,
          isVisor: true
        }),
        _react2.default.createElement(
          "div",
          { className: _Visor2.default.containerMap },
          this.renderMap()
        )
      );
    }
  }]);

  return Visor;
}(_react2.default.Component);

exports.default = Visor;


Visor.propTypes = {
  params: _propTypes2.default.object
};
